import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { getErrorMsg } from 'src/app/helpers/getErrorMsg';
import { ReferralsService } from 'src/app/services/referrals/referrals.service';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss',],
  encapsulation: ViewEncapsulation.None
})
export class ReferralsComponent implements OnInit {

  public loader: boolean;

  public types = {
    preview: 0,
    internal: 1,
    employee: 2
  }
  public type: number = 0;
  public internalStep = 0;

  public readonly maxLength = 255;
  public readonly allowedFileTypes = '.pdf,.doc,.docx,.xlsx';

  private motivationLetter: File;

  public form: FormGroup = new FormGroup({
    candidate_name: new FormControl(null, [Validators.required, notBlank, Validators.maxLength(this.maxLength)]),
    department: new FormControl(null, [Validators.required, notBlank, Validators.maxLength(this.maxLength)]),
    line_manager: new FormControl(null, [Validators.required, notBlank, Validators.maxLength(this.maxLength)]),
    vacancy_of_interest: new FormControl(null, [Validators.required, notBlank, Validators.maxLength(this.maxLength)]),
    recipient_email: new FormControl('travis@lcgroups.com', [Validators.required, Validators.email, Validators.maxLength(this.maxLength)]),
    motivation_letter: new FormControl(null, [Validators.required, Validators.pattern(/\.(pdf|doc|docx|xlsx)$/i)]),
  })

  constructor(
    private self: MatDialogRef<ReferralsComponent>,
    private referralsService: ReferralsService,
    private snackBar: MatSnackBar,
  ) { 
    this.self.addPanelClass('referrals-panel');
  }

  ngOnInit(): void {}

  public onSubmit(evt) {
    evt.preventDefault();
    if (!this.form.valid) { return; }
    this.loader = true;
    const formData = new FormData();
    for (const key in this.form.value) {
      if (key === 'motivation_letter') { continue; }
      formData.append(key, this.form.value[key].trim());
    }
    formData.append('motivation_letter', this.motivationLetter);
    this.referralsService.sendInvitation(
      formData
    ).toPromise().then((res) => {
      this.loader = false;
      this.showSnackBar('Your letter of motivation is uploaded successfully!');
      this.self.close()
    }, (err) => {
      this.onError(err);
    });
  }

  public onFileChange(evt) {
    const files = evt.target.files;
    if (!(files && files.length)) { return; }
    this.motivationLetter = files[0];
    this.form.get('motivation_letter').patchValue(this.motivationLetter.name);
    this.form.get('motivation_letter').markAsTouched();
  }

  private showSnackBar(text: string) {
    this.snackBar.open(text, 'Ok', { duration: 5000 });
  }

  private onError(err, loader = false) {
    this.loader = loader;
    const message = (err && err.error && err.error.message) || getErrorMsg(err);
    this.snackBar.open(message, 'Dismiss', {
      duration: 5000,
      panelClass: ['error-snackbar']
    });
  }
}

function notBlank(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  return typeof value === 'string' && value.length && !value.trim() ? { required: true } : null;
}
